import {
  homepage_presta_formation,
  parc_materiel_intro,
  supervision_intro,
} from "../../Imgs/images";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Pagination from "./Pagination/Pagination";
import "./Trainings.css";
import { useEffect, useState } from "react";

interface TrainingsProps {
  type: string;
}

const introImgs: any = {
  formation: homepage_presta_formation,
  supervision: supervision_intro,
  "service-entreprises": parc_materiel_intro,
};

const introTitles: any = {
  formation: "Formations",
  supervision: "Supervision",
  "service-entreprises": "Services aux entreprises",
};

const introDescriptions: any = {
  formation:
    "Retrouvez les formations outils, sauveteur secouriste du travail, habilitation électrique, équipement de protection individuelle et chantier.",
  supervision:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Bibendum est ultricies integer quis. Iaculis urna id volutpat lacus laoreet. Mauris vitae ultricies at sinc tempor incididunt.",
  "service-entreprises":
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Bibendum est ultricies integer quis. Iaculis urna id volutpat lacus laoreet. Mauris vitae ultricies at sinc tempor incididunt.",
};

const filesByType: any = {
  formation: "formations.json",
  supervision: "supervisions.json",
  "service-entreprises": "services.json",
};

function Trainings(props: TrainingsProps) {
  const [trainings, setTrainings] = useState([]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_DOMAIN}api/trainings/${filesByType[props.type]}`,
    )
      .then((response) => response.json())
      .then((response) => setTrainings(response))
      .catch((error) => {
        console.log(error);
      });
  }, [props.type]);

  return (
    <>
      <Header additionalClass={props.type} />
      <section className="sp-intro">
        <picture className="sp-training-bg-img">
          <source srcSet={introImgs[props.type]} />
          <img
            src={introImgs[props.type]}
            alt="Représentation de la typologie des formations"
          />
        </picture>
        <h1 className="sp-intro-title">{introTitles[props.type]}</h1>
        <p className="sp-intro-description">{introDescriptions[props.type]}</p>
      </section>
      <section className="trainings-content">
        <div className="trainings-content-container">
          <div className="trainings-content-header">
            <h2 className="trainings-header-title">Nos formations</h2>
            {/* <div className="trainings-header-filters">
              <select className="trainings-filters-select">
                <option value="">Trier par</option>
              </select>
            </div> */}
          </div>
          <Pagination trainings={trainings} type={props.type} />
        </div>
      </section>
      {/* <section className="trainings-quality">
        <div className="trainings-quality-container">
          <div className="trainings-quality-garanty">
            <h3 className="trainings-quality-garanty-title">
              Notre garantie qualité
            </h3>
            <p className="trainings-quality-garanty-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
              Bibendum est ultricies integer quis. Iaculis urna id volutpat
              lacus laoreet. Mauris vitae ultricies at sinc tempor incididunt
              Bibendum est ultricies integer quis. Iaculis urna id volutpat
              lacus laoreet. Mauris vitae ultricies at sinc tempor incididunt.
            </p>
          </div>
          <picture className="trainings-quality-qualiopi">
            <source srcSet={training_qualiopi} />
            <img src={training_qualiopi} alt="Qualiopi certification" />
          </picture>
        </div>
      </section> */}
      <Footer />
    </>
  );
}

export default Trainings;
